import Dashed from './dashed';
import Circle from './circle';

export default {
  Dashed,
  Circle,
};
